import React, { useState } from 'react';
import { Data, DataState } from '../../types/data-providers';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { ApiResponse } from '../../api/api-request-helpers';
import { GenericNotOkResponse, ManageAlarmsConfigDetailsOkResponse } from '../../api/types';
import * as ApiRequests from '../../api/requests';
type AlarmConfigData = {
    alarmConfig: Data<any>;
    getAlarmConfigData: Function;
    
};
const Context = React.createContext<AlarmConfigData | null>(null);
function useAlarmConfigData(): AlarmConfigData {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useAlarmConfigData must be used within a AlarmConfigProvider');
    }
    return contextState;
}
const AlarmConfigProvider: React.FC<{ deviceId: string; channels: string }> = (props) => {
    const [alarmConfig, setAlarmConfig] = useState<Data<any>>({ state: DataState.Loading });
    const authHelper = useAuthHelper();
    const getDataByAPI = async (
        deviceId: string,
        channels: string
    ): Promise<ApiResponse<ManageAlarmsConfigDetailsOkResponse, GenericNotOkResponse>> => {
        const deviceMasterResult = await ApiRequests.getAlarmConfig(
            {
                deviceChannelKeys: [{ deviceId: deviceId, channels: [channels] }],
            },
            { authHelper }
        );
        return deviceMasterResult;
    };
    const getAlarmConfigData = async (deviceId: string, channels: string): Promise<void> => {
        setAlarmConfig({
            state: DataState.Loading,
        });
        const alarmConfigResult = await getDataByAPI(deviceId, channels);
        const result = alarmConfigResult.ok
            ? setAlarmConfig({
                  state: DataState.Loaded,
                  value: alarmConfigResult.response.data,
              })
            : setAlarmConfig({
                  state: DataState.Error,
                  errorMessage: ApiRequests.extractErrorCodeWithMessage(alarmConfigResult.response),
              });
        return result;
    };
    return <Context.Provider value={{alarmConfig,getAlarmConfigData}}>{props.children}</Context.Provider>;
};
const TestStarfishChildDeviceDataProvider: React.FC<{ value: AlarmConfigData }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);
export { AlarmConfigProvider, TestStarfishChildDeviceDataProvider, useAlarmConfigData };